import { forwardRef } from 'react';
import { VariantProps, cva } from 'class-variance-authority';
import { cn } from '@/utils/tailwind';

const buttonVariants = cva('select-none transition-colors focus:outline-none', {
  variants: {
    variant: {
      SolidHigh: 'text-white bg-point-500 active:bg-point-400 disabled:bg-gr-200',
      SolidLow: 'text-gr-700 bg-gr-100 active:bg-gr-200 disabled:text-white disabled:bg-gr-200',
      OutlineHigh:
        'text-point-500 bg-white active:text-point-400 active:bg-gr-100 disabled:text-gr-300 disabled:bg-white border-[1px] disabled:border-gr-200 border-point-500 active:border-primary-400',

      OutlineLow:
        'text-gr-700 bg-white active:bg-gr-100 disabled:text-gr-300 disabled:bg-white border-[1px] disabled:border-gr-200 border-gr-200 active:border-gr-200',
      Secondary:
        'text-point-500 bg-point-100 fill-point-500 active:bg-point-150 disabled:bg-gr-200',
      Solid: 'text-gr-700  bg-gr-100 active:bg-gr-200 disabled:text-white disabled:bg-gr-200',
    },
    width: {
      full: 'w-full',
      '18': 'px-[18px]',
      '13': 'px-[13px]',
      '10': 'px-[10px]',
      '8': 'px-[8px]',
    },
    height: {
      '52': 'h-[52px] Body1S16 rounded-[16px]',
      '44': 'h-[44px] Body3S15 rounded-[12px]',
      '38': 'h-[38px] text-[14px] font-bold leading-[22px] rounded-[8px]',
      '34': 'h-[34px] Body4S14 rounded-[8px]',
      '28': 'h-[28px] Caption1M12 rounded-[8px]',
      '26': 'h-[26px] Caption1M12 rounded-[8px]',
    },
  },
  defaultVariants: {
    height: '52',
    variant: 'SolidHigh',
    width: 'full',
  },
});

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> &
  VariantProps<typeof buttonVariants> & {
    isLoading?: boolean;
    loadingClassName?: string;
  };

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      className,
      loadingClassName,
      variant,
      width,
      height,
      isLoading,
      disabled,
      children,
      ...props
    },
    ref,
  ) => {
    return (
      <button
        ref={ref}
        className={cn(
          buttonVariants({
            variant,
            width,
            height,
            className,
          }),
        )}
        disabled={isLoading ? true : disabled}
        {...props}
      >
        {children}
      </button>
    );
  },
);

Button.displayName = 'Button';
